import type { CuisineItem } from '../types.js';

export const CUISINE: CuisineItem[] = [
	{
		id: 'hongdae-barcrawl',
		name: 'Book a bar crawl in Hongdae',
		ko: '홍대',
		emoji: '🍻',
		kind: 'experience',
		note: 'Join a guided pub crawl through Hongdae’s student nightlife — bars, drinking games, and a crew to roam the streets with. Book ahead online.',
	},
	{
		id: 'milkbread',
		name: 'Milk bread',
		ko: '밀크 식빵',
		emoji: '🍞',
		kind: 'dish',
		note: 'Pillowy, lightly sweet Korean milk bread — a bakery staple, soft and fluffy.',
	},
	{
		id: 'tteokbokki',
		name: 'Tteokbokki',
		ko: '떡볶이',
		emoji: '🌶️',
		kind: 'dish',
		note: 'Chewy rice cakes simmered in sweet-spicy gochujang sauce. The street-food icon.',
	},
	{
		id: 'kimbap',
		name: 'Kimbap',
		ko: '김밥',
		emoji: '🍙',
		kind: 'dish',
		note: 'Seaweed-and-rice rolls with veg, egg and meat. Cheap, portable, perfect.',
	},
	{
		id: 'bibimbap',
		name: 'Bibimbap',
		ko: '비빔밥',
		emoji: '🥗',
		kind: 'dish',
		note: 'Rice topped with seasoned vegetables, egg and gochujang — mix it all together.',
	},
	{
		id: 'kimchi',
		name: 'Kimchi',
		ko: '김치',
		emoji: '🥬',
		kind: 'dish',
		note: 'Fermented, spiced cabbage — the national side dish, served with everything.',
	},
	{
		id: 'kfc',
		name: 'Korean Fried Chicken',
		ko: '치킨',
		emoji: '🍗',
		kind: 'dish',
		note: 'Double-fried, shatteringly crispy and glazed. Pair with beer = chimaek (치맥).',
	},
	{
		id: 'store-ramen',
		name: '24-hr self-service store ramen',
		ko: '라면',
		emoji: '🍜',
		kind: 'dish',
		note: 'Grab a cup ramyeon and cook it at the convenience-store machine — a late-night rite of passage.',
	},
	{
		id: 'cvs',
		name: '7-Eleven & convenience stores',
		ko: '편의점',
		emoji: '🏪',
		kind: 'dish',
		note: 'CU, GS25, 7-Eleven: triangle kimbap, banana milk, hotbars, tubs of ice cream — graze your way around.',
	},
];
